module.exports = __webpack_public_path__ + "img/people@2x.6a12a89a.png";